/*
 *		Copyright (c) 2011-2018 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .filter('displayMember', ['$translate', function ($translate) {
        return function(member) {
            var
                emailOrName = member.email || member.name;

            if(emailOrName) {
                return emailOrName;
            } else {
                return $translate.instant('members_dialog_unknown_member');
            }
        }
    }]);
